import { render, staticRenderFns } from "./global-meta.vue?vue&type=template&id=63f98856&scoped=true&"
import script from "./global-meta.ts?vue&type=script&lang=ts&"
export * from "./global-meta.ts?vue&type=script&lang=ts&"
import style0 from "./global-meta.scss?vue&type=style&index=0&id=63f98856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f98856",
  null
  
)

export default component.exports